// extracted by mini-css-extract-plugin
module.exports =  {"tableWrapper":"AssetTable-module__tableWrapper--rnSfv","tickerCell":"AssetTable-module__tickerCell--DTt_F","ticker":"AssetTable-module__ticker--bHeJ4"};